// @subframe/sync-disable
import React, { useState } from "react";
import * as SubframeCore from "@subframe/core";
import { LinkButton } from "./LinkButton";
import { Button } from "./Button";
import AuthModal from "components/AuthModal/AuthModal";
import { useNavigate } from "react-router-dom";

interface SessionProps {
  session: { user: { username?: string; id: string; email?: string } } | null;
  onLogout: () => void;
}

interface BoldNavbarRootProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  aboutClicked?: () => void;
  session?: SessionProps["session"];
  onLogout?: () => void;
}

const BoldNavbarRoot = React.forwardRef<HTMLElement, BoldNavbarRootProps>(
  function BoldNavbarRoot({ className, aboutClicked, session, onLogout, ...otherProps }, ref) {
    const navigate = useNavigate();
    const userName = session?.user?.username;

    // Modal States
    const [isSignUpOpen, setIsSignUpOpen] = useState(false);
    const [isLoginOpen, setIsLoginOpen] = useState(false);

    return (
      <>
        {/* Sign-Up & Login Modals */}
        <AuthModal open={isSignUpOpen} onOpenChange={setIsSignUpOpen} isSignUp={true} />
        <AuthModal open={isLoginOpen} onOpenChange={setIsLoginOpen} isSignUp={false} />

        {/* Navbar */}
        <div className="fixed top-0 left-0 z-50 w-full bg-default-background shadow-md">
          <div className="flex w-full flex-col items-center justify-center px-6 py-4">
            <div
              className={SubframeCore.twClassNames(
                "flex w-full max-w-[1280px] flex-wrap items-center gap-4",
                className
              )}
              ref={ref as any}
              {...otherProps}
            >
              <div className="flex h-12 flex-col items-start justify-center gap-2 px-4">
                <img
                  className="h-14 flex-none object-cover cursor-pointer"
                  src="https://i.imgur.com/Q79snHK.png"
                  alt="Logo"
                  onClick={() => navigate("/")}
                />
              </div>
              <div className="flex grow shrink-0 basis-0 items-center justify-end gap-2 px-2">

                {aboutClicked && <LinkButton onClick={aboutClicked}>About</LinkButton>}

                {session ? (
                  <div className="flex items-center gap-4">
                    <span className="text-[15px] font-[600] leading-[20px] text-brand-900">
                      {userName}
                    </span>
                    <Button variant="brand-tertiary" onClick={onLogout}>
                      Logout
                    </Button>
                    <Button variant="brand-primary" onClick={() => navigate("/home")}>
                      Home
                    </Button>
                  </div>
                ) : (
                  <>
                    <Button variant="brand-tertiary" onClick={() => setIsLoginOpen(true)}>
                      Log in
                    </Button>
                    <Button onClick={() => setIsSignUpOpen(true)}>Sign up</Button>
                  </>
                )}

              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export const BoldNavbar = BoldNavbarRoot;
